<template>
  <a-card :bordered="false">
    <search-page-view
      :col="2"
      ref="pageList"
      :itemNames="['s1','s2','s3']"
      :buttonItems="['add']"
      :columns="getColumns()"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="10"
      :requestPromise="getTaskList"
    >
      <a-form-item slot="s1" label="任务类型" v-bind="searchItemLayout">
        <a-select placeholder="请选择" :allowClear="true" style="width: 100%" v-model="queryParams.taskType">
          <a-select-option value="1">
            收藏
          </a-select-option>
          <a-select-option value="2">
            商品浏览量
          </a-select-option>
          <a-select-option value="3">
            下单金额
          </a-select-option>
          <a-select-option value="4">
            下单数量
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="s2" label="可领任务时间" v-bind="searchItemLayout">
        <a-range-picker
          style="width: 400px"
          @change="onDateChange"
        />
      </a-form-item>
      <a-form-item slot="s3" label="商品ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-button slot="add" type="primary" style="margin-left: 20px" @click="addEvent">+ 新建
      </a-button>
      <div slot="operation" style="height: 40px">
              <span style="float: right">
              <span>复制</span>
                <a
                  @click="showLinkModal"
                  style="margin-left: 10px">活动链接</a>
              </span>
      </div>
      <span slot="drawDate" slot-scope="rowItem">
        {{ rowItem.record.validStartTime }}~{{ rowItem.record.validEndTime }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <template v-if="rowItem.record.status !==0"></template>
        <template v-if="rowItem.record.status !==2">
          <a v-if="rowItem.record.status ==1" @click="pullOff(rowItem.record)">下线</a>
          <a v-if="rowItem.record.status ==0" @click="putOn(rowItem.record)">投放</a>
          <a-divider type="vertical"/>
        </template>
        <template v-if="rowItem.record.status !==0">
          <a @click="toEditEvent(rowItem.record,1)">查看</a>
          <a-divider type="vertical"/>
          <a @click="toStatisticsEvent(rowItem.record)">数据统计</a>
        </template>
        <template v-if="rowItem.record.status ==0">
          <a-divider type="vertical"/>
        <a @click="toEditEvent(rowItem.record,2)">编辑</a>
        </template>

      </span>
    </search-page-view>
    <a-modal
      title="复制链接"
      :width="500"
      v-model="visible"
      @cancel="visible=false"
      :destroyOnClose='true'
      :footer="null"
    >
      <a-textarea
        :disabled="true"
        v-model="urlLink"
        :autoSize="{ minRows: 3, maxRows: 5 }"
      />
      <a-button
        v-clipboard:copy="urlLink"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        style="margin-top:20px" type="primary">复制
      </a-button>
    </a-modal>
  </a-card>
</template>

<script>
//营销任务
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'MarketingTask',
  mixins: [salesTaskMixins],
  data() {
    return {
      urlLink: '',
      visible: false
    }
  },
  created() {
    this.queryParams = {
      merchantId: this.merchantId,
      platformId: this.platformId
    }
  },
  mounted() {
  },
  methods: {
    showLinkModal() {
      this.visible = true
      this.getLinkUrl()
    },
    getLinkUrl() {
      let domainUrl = this.getAppConfig().platformConfig.h5Url
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      let params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      this.urlLink = RouterSwitchHelper.getSalesTaskPathUrl(domainUrl, params)
    },
    onCopy(e) {
      this.$message.success('复制成功')
    },
    onError(e) {
      this.$message.error('移除失败')
    },
    getColumns() {
      return [
        {
          title: '任务ID',
          dataIndex: 'id'
        },
        {
          title: '任务类型',
          dataIndex: 'taskTypeName'
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '领取任务x天内，完成有效',
          dataIndex: 'receiveValidDays'
        },
        {
          title: '可领任务时间',
          dataIndex: 'drawDate',
          scopedSlots: { customRender: 'drawDate' }
        },
        {
          title: '状态',
          dataIndex: 'statusName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    pullOff(record) {
      this.getHttpServices().getUserService().post('staff/marketTask/pullOff/' + record.id)
        .then(res => {
          this.$message.success('下线成功')
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    putOn(record) {
      this.getHttpServices().getUserService().post('staff/marketTask/putOn/' + record.id)
        .then(res => {
          this.$message.success('投放成功')
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDateChange(dates, dateStrArr) {
      this.queryParams.validStartTime = dateStrArr[0]//开始时间
      this.queryParams.validEndTime = dateStrArr[1]//结束时间
    },
    getTaskList(params) {
      return this.getHttpServices().getUserService().post('staff/marketTask/settingList', params)
    },
    addEvent() {
      let pageParams = this.getPageParams()
      this.openNewPage('MarketingTaskCreator', { ...pageParams })
    },
    toStatisticsEvent(record) {
      let pageParams = this.getPageParams()
      this.openNewPage('MarketingStatistics', { ...pageParams, taskId: record.id })
    },
    toEditEvent(record, type) {
      let pageParams = this.getPageParams()
      let param = {
        ...pageParams,
        taskId: record.id
      }
      if (type == 1) {
        param.disableType = 1
      }
      this.openNewPage('MarketingTaskEditor', param)

    }
  }

}
</script>
<style scoped>
</style>